import { ACPVariant } from 'apps/acp/variants/acp-variant';

const colors = {
  neutral: {
    color50: '#fafafa',
    color100: '#f0f3f3',
    color200: '#ececec',
    color300: '#cccccc',
    color400: '#ababab',
    color500: '#8b8b8b',
    color600: '#666667',
    color700: '#414142',
    color800: '#2b2b2c',
    color900: '#161616'
  },
  default: {
    color50: '#dfdfe0',
    color100: '#c0c0c0',
    color200: '#a0a0a1',
    color300: '#808081',
    color400: '#616162',
    color500: '#414142',
    color600: '#343435',
    color700: '#272728',
    color800: '#1a1a1a',
    color900: '#0d0d0d'
  },
  accent: {
    color50: '#f9dbda',
    color100: '#f3b8b4',
    color200: '#ee948f',
    color300: '#e87069',
    color400: '#e24d44',
    color500: '#dc291e',
    color600: '#b02118',
    color700: '#841912',
    color800: '#58100c',
    color900: '#2c0806'
  },
  positive: {
    color50: '#ebf4d5',
    color100: '#d6e9aa',
    color200: '#c2de80',
    color300: '#add355',
    color400: '#99c82b',
    color500: '#84bd00',
    color600: '#6a9700',
    color700: '#4f7100',
    color800: '#354c00',
    color900: '#1a2600'
  },
  negative: {
    color50: '#f9dbda',
    color100: '#f3b8b4',
    color200: '#ee948f',
    color300: '#e87069',
    color400: '#e24d44',
    color500: '#dc291e',
    color600: '#b02118',
    color700: '#841912',
    color800: '#58100c',
    color900: '#2c0806'
  },
  special: {
    color50: '#d5edf4',
    color100: '#aadbe9',
    color200: '#80c9de',
    color300: '#55b6d2',
    color400: '#2ba4c7',
    color500: '#0092bc',
    color600: '#007596',
    color700: '#005871',
    color800: '#003a4b',
    color900: '#001d26'
  }
};

const variant: ACPVariant = {
  id: 'www.hebprepaid.com',
  productTitle: 'H-E-B Prepaid Account',
  productType: 'gpr',
  accessDomain: {
    subdomain: 'www',
    domain: 'hebprepaid',
    topLevelDomain: 'com'
  },
  colors,
  themeConfiguration: {
    acpDashboard: {
      accountLinkColor: colors.special.color500,
      accountChevronColor: 'special',
      savingsAccountSetupButtonColor: 'special'
    },
    acpLoginTheme: {
      overrideLinkColor: colors.special.color500
    },
    acpDynamicFaqTheme: {
      overrideLinkColor: colors.special.color500
    },
    acpEsignTheme: {
      overrideLinkColor: colors.special.color500
    },
    acpSecureUploadTheme: {
      overrideLinkColor: colors.special.color500
    },
    acpUnAuthLayout: {
      overrideLinkColor: colors.special.color500
    },
    acpHandOffTheme: {
      overrideLinkColor: colors.special.color500
    },
    systemIcon: {
      primary: colors.special.color500
    },
    typography: {
      links: {
        active: colors.special.color500,
        inactive: colors.special.color500
      }
    }
  },
  legacyAcpTheme: 'heb',
  legacyAcpBrandName: 'heb',
  legacyLegosTheme: 'heb',
  status_bar_background_color: colors.default.color500,
  status_bar_foreground_color: 'light',
  contactInfo: {
    name: 'H-E-B Prepaid',
    contact_address_line1: 'PO Box 2136',
    contact_address_line2: 'Austin, TX 78768-2136',
    contact_address_line3: '',
    customer_support_email: 'customerservice@hebprepaid.com',
    fax_formatted: '(855) 439-6488',
    phone_formatted: '(866) 387-7363',
    phone: '1-866-387-7363',
    phone_international: '737-220-8956',
    balance_check_phone: '8663877363',
    balance_check_phone_formatted: '1-866-387-7363',
    pre_funded_checks_phone: '18778147683',
    pre_funded_checks_phone_formatted: '1-877-814-7683'
  },
  configuration: {
    apiKeys: {
      appsFlyerDevKey: '5Us7NeWk6WVjGLsAnKioSk',
      appsFlyerBannerKey: '1599ee80-0362-4c23-9964-47c6094f988b',
      'google-tag-manager-container-id': 'GTM-NQXKPD',
      'google-tag-manager-container-id-mobile': 'GTM-MWBTT5M',
      paypalFraudNetPayerIdProd: '',
      paypalFraudNetPayerIdTest: ''
    },
    featureToggles: {
      activationSetExternalId: false,
      appsFlyerEnabled: false,
      combinedTransactionsMasterAndSub: false,
      'embedded-activation': true,
      embeddedPayNearMe: false,
      hasNotificationCenter: false,
      mobilePBREnabled: true,
      preOnboardingEnabled: false,
      showAccountDisplayNickname: false,
      showAcquisitionLink: true,
      showATMFriendlyCards: true,
      showDisplayNameForSubAccount: false,
      showEmailInformationButton: true,
      showFeePlanPage: false,
      showHowToEarnRewardPointLink: true,
      showRegisterLink: true,
      showScanCardRegistration: true,
      showMarketingSiteLink: true,
      showFreeAtmFinderLink: false,
      showWUTransfers: false,
      showReloadLocationLink: true
    },
    misc: {
      distributor: 'HEB',
      layoutComponentOverride: false,
      loader: 'generic',
      payNearMeButtonTextColor: '#FFFFFF',
      payNearMeActionBarBackgroundColor: '#414142',
      payNearMeTitleTextColor: '#FFFFFF',
      payNearMeColorAccent: '#84bd00',
      marketingSiteUrl: 'https://www.hebprepaid.com',
      marketingSiteLinkText: 'Hebprepaid.com',
      locationSearchMax: '25',
      iOSAppId: '932968683'
    },
    content: {
      signUpContent: "Don't have a card? Sign up today."
    },
    disclaimers: {},
    sections: [
      'dashboard-gpr',
      'dashboard-lite',
      'dashboard-handoff',
      'layout',
      'manage-gpr',
      'move-money',
      'overdraft',
      'locations',
      'direct-deposit',
      'direct-deposit-mobile-panel',
      'statements',
      'contact-us',
      'restrictions-readonly',
      'feeplan',
      'western-union',
      'disclosure-dictionary',
      'check-deposit',
      'checks',
      'quickbooks-oauth',
      'points',
      'post-handoff-to-activate-register',
      'upgrade',
      'offers',
      'offers-intro',
      'tours',
      'post-install-multi-screen-acquisition-flow',
      'echecks',
      'external-loyalty',
      'secure-inbox',
      'benefit-center',
      'atm-finder',
      'savings',
      'pay-bills',
      'premier-plan',
      'activation',
      'savings-transfer',
      'anytime-alerts',
      'anytime-alerts-upgrade',
      'change-username',
      'change-password',
      'mobile-check-load',
      'feedback',
      'rent-track',
      'direct-deposit-form',
      'dynamic-faq',
      'billpay',
      'card',
      'refer-a-friend',
      'close-account',
      'points-learn-more',
      'family-cards',
      'bank-transfers',
      'handoff',
      'debit-card-transfers',
      'card-use-settings',
      'secure-upload',
      'digital-wallet',
      'me-to-me-transfer',
      'money-gram',
      'survey',
      'debit-card-transfers-disbursement',
      'spend-money',
      'fraud-detection',
      'spending-tracker',
      'connected-banks',
      'interstitials',
      'dd-tracker'
    ]
  }
};

export default variant;
